<template>
  <div class="space-y-6 pb-10">
        <section aria-labelledby="current_subscriptions" class="" v-if="authUserStore.user.academy.saas_subscriptions">
          <div v-if="this.authUserStore.user.academy.saas_subscriptions[0].status === 'past_due'" class="lg:mx-20 my-6 flex justify-center">
            <div class="flex flex-row justify-center bg-yellow-100 border-yellow-200 border rounded-lg p-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 text-yellow-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <label class="text-yellow-700">{{$t('settings.message_subscription_expire')}}</label>
            </div>
          </div>
          <div v-else-if="this.authUserStore.user.academy.saas_subscriptions[0].status === 'canceled'" class="lg:mx-20 my-6 flex justify-center">
            <div class="flex flex-row justify-center bg-red-700 border-red-400 border rounded-lg p-4 mx-6">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <label class="text-white">{{$t('myaccount.canceled_message')}}</label>
            </div>
          </div>
          <div v-else-if="this.authUserStore.user.academy.saas_subscriptions[0].status === 'trialing'" class="lg:mx-20 my-6 flex justify-center">
            <div class="flex flex-row items-center bg-amber-50 border border-amber-200 rounded-lg p-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 text-amber-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <label class="text-amber-800">
                <span class="font-semibold">{{ $t('settings.trial_banner_title', { days: academiesStore.remainingTrialDays }) }}</span>
                {{ $t('settings.trial_banner_text') }}
              </label>
            </div>
          </div>

          <section class="mb-16 ">
            <change-subscription-component></change-subscription-component>
          </section>
        </section>
  </div>
</template>

<script>

import ChangeSubscriptionComponent from "./ChangeSubscriptionComponent";
import {useAuthUserStore} from "@/stores/auth";
import {useAcademiesStore} from "@/stores/academies";

export default {
  name: "CurrentSubscriptionsComponent",
  components: {ChangeSubscriptionComponent},
  setup(){
    const authUserStore = useAuthUserStore()
    const academiesStore = useAcademiesStore()

    return {
      authUserStore,
      academiesStore
    }
  },
}
</script>

<style scoped>

</style>
